import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY env vars');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Build a public URL for a file in the 'images' storage bucket.
 * @param {string} path – e.g. "products/classic-smash-burger.jpg"
 * @returns {string} full public URL
 */
export function getImageUrl(path) {
  if (!path) return null;
  const { data } = supabase.storage.from('images').getPublicUrl(path);
  return data?.publicUrl ?? null;
}
